import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';

import { Participations } from '@app/models';
import { UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';

@Component({
  templateUrl: './modal-parts-on-sale.component.html',
  styleUrls: ['./modal-parts-on-sale.component.scss']
})
export class ModalPartsOnSaleComponent {

  part: Participations;
  participations: { amount: number; createAt: number; sold: number; id: string }[] = [];
  trashIcon = faTrashAlt;

  constructor(
    private userServ: UserService,
    private modalServ: ModalService,
    private toastrServ: ToastrService,
    private dialog: MatDialogRef<ModalPartsOnSaleComponent>
  ) { }

  openModalCancelPartsOnSale(move: { amount: number; createAt: number; sold: number; id: string }) {
    const activeParts = move.amount - move.sold;

    const vm = this.modalServ.modalCustom({
      img: 'https://static.monific.com/assets/assets-app/img/icon/img/attention.svg',
      title: `¿Cancelar la venta de ${activeParts} ${activeParts === 1 ? 'participación' : 'participaciones'} de ${this.part.devName}?`,
      message: 'Para ponerlas de nuevo a la venta deberás hacerlo desde Proyectos > Fondeados.',
      buttonText: 'Cancelar venta',
      cancelText: 'No cancelar'
    });

    vm.beforeClosed().subscribe(btnTrue => {
      if (btnTrue) this.cancelPartsOnSale(move)
    });
  }

  cancelPartsOnSale(move: { amount: number; createAt: number; sold: number; id: string }) {
    const activeParts = move.amount - move.sold;

    this.userServ.cancelOnSaleActive(move.id).subscribe({
      next: res => {
        if (res) {
          this.modalServ.modalCustom({
            img: 'https://static.monific.com/assets/assets-app/img/icon/img/success-delete.svg',
            title: 'Venta cancelada',
            message: `La publicación con ${activeParts} ${activeParts === 1 ? 'participación' : 'participaciones'} de ${this.part.devName} se ha cancelado.`,
            buttonText: 'Entendido',
            // footer: 'Te hemos enviado un correo como comprobante de esta operación.'
          });
          this.userServ.getOnSaleActive(this.part.devId).subscribe(r => this.participations = r);
        } else {
          this.toastrServ.warning('Hubo un error al intentar al cancelar la venta de participaciones.');
        }
      },
      error: err => this.toastrServ.warning('Hubo un error al intentar cancelar la venta de participaciones.')
    });
  }

  closeModal() {
    this.dialog.close();
  }

}
